var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm4.409-14.5h-1.533l-2.527 2.888L10.164 7.5H7l3.78 4.944-3.583 4.095h1.535l2.765-3.16 2.417 3.16H17l-3.941-5.21 3.35-3.829Zm-1.222 8.121h-.85L8.791 8.37h.911l5.485 7.251Z",
    fill: "currentColor"
  })));
};
export default SvgTwitter;